import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {useQueryLeave} from "@/service/leave.s";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import {Grid, Stack} from "@mui/material";
import {isNumber} from "lodash";
import {formatTime} from "@/helper/method";
import {useDrawerModal} from "@/store/global.c";

export const ViewLeave: FC = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: leaveData, isLoading: leaveLoading} = useQueryLeave({id: drawerId!}, isNumber(drawerId))
    const leave = leaveData?.data
    return <> <ResultWrapper isLoading={leaveLoading} isEmpty={isEmpty(leave)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid
                spacing={3}
                container>
                <GridItem title={'请假人'} content={leave?.creator}/>
                <GridItem title={'请假类型'} content={leave?.categories}/>
                <GridItem title={'请假时间'} content={`${formatTime("m", leave?.startTime)}至${formatTime("m", leave?.endTime)}`}/>
                <GridItem title={'创建时间'} content={formatTime("M", leave?.createdAt)}/>
                <GridItem minHeight={'48px'} size={12} title={'请假原由'} content={leave?.reason}/>
            </Grid>
        </Stack></ResultWrapper>
    </>
}